import React, { useEffect, useRef, useState } from "react";
import bgImage from "assests/Project/bg3.jpg";
import Container from "Components/Container/Container";
import academyData from "Constant/Academy";
import { ArrowUpRight } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import "./style.css";

const Academy = ({ data }) => {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5, // Adjust the threshold as needed
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setVisible(true);
        } else {
          setVisible(false);
        }
      });
    }, options);

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <div
      ref={sectionRef}
      className="scroll-section relative py-primary overflow-hidden flex items-center justify-center"
    >
      <div
        className={`absolute left-0 top-0 w-full h-full transition ease-in duration-500 z-[0] accedmy-zoom ${
          visible ? "zoomed opacity-100" : "opacity-0"
        }`}
      >
        <img src={bgImage} alt="" className="w-full h-full object-cover" />
      </div>
      <Container className="relative">
        <div>
          <h4 className="title text-center">latest news</h4>
          {/* <p className="sub_title text-center lg:w-1/2 lg:mx-auto">
            limited information is available about the academy and it's offering
            s, including the benefits and who can benefit from them
          </p> */}
        </div>

        <div className="flex flex-col lg:flex-row  mx-auto gap-10 items-stsretch justify-center mt-24">
          {data?.map(({ title, image, date, slug, category }, index) => (
            <Link
              to={`/news/${slug}`}
              key={index}
              className="flex-1 flex gap-x-4 bg-[#00000096] hover:bg-black transition ease-in duration-300  text-white p-2 rounded-xl"
            >
              <div className="w-full">
                <img
                  className="h-[250px] w-full object-cover"
                  src={image}
                  alt=""
                />
                <p className="my-2">{category}</p>
                <p className="my-2">{date}</p>
                <p className="text-2xl font-bold  mb-4">{title}</p>
              </div>
            </Link>
          ))}
        </div>
      </Container>
    </div>
  );
};

export default Academy;
